import { gql, useMutation } from '@apollo/client'

import { segmentsClient } from '../../../../utils/apollo/api'
import { useNavigation } from '../../../../utils/contexts/NavigationContext'
import { useSegmentationForm } from '../_form/SegmentationFormHandler'
import { cleanRequest } from './cleanRequest'

const MUTATION = gql`
  mutation UpsertSegment($input: SegmentInput) {
    upsertSegment(input: $input) {
      id
    }
  }
`

export const useSaveSegmentationRequest = () => {
  const form = useSegmentationForm()
  const navigate = useNavigation()
  const input = cleanRequest(form)

  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Segments', 'Segment'], client: segmentsClient })

  const handleRequest = () => {
    return request({ variables: { input } }).then(resp => {
      navigate('/segmentations')
    })
  }

  return [handleRequest, state]
}
